"use client";

import dynamic from "next/dynamic";

/**
 * Client-only boundary for the Europe map.
 *
 * `react-simple-maps` projects coordinates through `d3-geo`, which leans on
 * transcendental math (sin/cos/atan). Node's V8 and the browser's V8 can differ
 * in the last unit-in-last-place, so the server and the client produce
 * `transform="translate(312.847…, 236.17638111528004)"` vs
 * `…236.1763811152798` for the same point — React reports that as a hydration
 * mismatch and re-renders the subtree on the client.
 *
 * Rendering the map only on the client removes the mismatch at its source.
 * Nothing is lost for SEO: the map draws country paths and marker glyphs, and
 * carries no prose. It is also desktop-only — `#europe-map .map-container` is
 * `display: none` below 768px, where a static image stands in instead.
 *
 * This wrapper exists because `next/dynamic` with `ssr: false` is not allowed
 * inside a Server Component in the App Router, and the landing page is one.
 */
const SimpleMaps = dynamic(() => import("./SimpleMaps"), {
  ssr: false,
  // ComposableMap renders an 800×600 viewBox at width:100%/height:auto, so a
  // 4:3 box holds the exact space the map takes and mounting causes no shift.
  loading: () => <div className="map-placeholder" aria-hidden />,
});

export default function SimpleMapsClient() {
  return <SimpleMaps />;
}
